import {
  Breadcrumbs,
  Button,
  Container,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import axios from "axios";
import { useState } from "react";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import { Page } from "components";
import { hardBaseUrl } from "../../../../services/urlConstant";

const theme = createTheme({
  typography: {
    fontFamily: ["Inter"].join(","),
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
    borderTop: "1px solid #e1e1e1",
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    padding: "10px 28px 10px 28px",
    backgroundColor: "black",
    color: "white",
    width: "213px",
    height: "40px",
    borderRadius: "6px",
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  },
  subtitle: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "28px",
  },
  breadcrumbs: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#111827",
  },
  breadCrumbsActive: {
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "regular",
    color: "#687083",
  },
  selectPadding: {
    height: "80px",
    "& .MuiInputBase-fullWidth": {
      height: "55px",
    },
  },
  rootSwitch: {
    width: "40px",
    height: "20px",
    padding: "0px",
    borderRadius: "10px",
    marginRight: "8px",
    position: "relative",
  },
  switchBase: {
    padding: "10px",
    color: "white",
    "&.Mui-checked": {},
    "&.Mui-checked + $track": {
      border: "none",
      color: "white",
      backgroundColor: "black",
      opacity: 1,
    },
  },
  checked: {},
  thumb: {
    color: "white",
    position: "absolute",
    width: "16px",
    height: "16px",
  },
  track: {
    backgroundColor: "#E4E7EB",
    borderRadius: "25px",
    border: "0px solid #606060",
    height: "auto",
    opacity: 1,
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
    />
  );
}

const CreateTax = () => {
  const classes = useStyles();
  const history = useHistory();
  const [name, setName] = useState("");
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [description, setDescription] = useState("");

  const handleChange = e => {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "name") {
      setName(value);
    } else if (name === "taxPercentage") {
      setTaxPercentage(value);
    } else if (name === "description") {
      setDescription(value);
    }
  };

  const saveData = e => {
    e.preventDefault();
    const data = {
      name: name,
      value: Number(taxPercentage),
      description: description,
    };

    const url = `${hardBaseUrl}/publisher/configuration/tax`;
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        "Content-Type": "application/json",

        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .post(url, data, config)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Tax Created Successfully",
        }).then(result => {
          if (result.isConfirmed) {
            history.push("/admin/master/tax");
          }
        });
      })
      .catch(err => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.errors.message,
        });
      });
  };

  return (
    <Page className={classes.root} title="Add Tax">
      <Container maxWidth={false}>
        <Grid
          alignItems="flex-end"
          container
          justifyContent="space-between"
          spacing={3}
        >
          <Grid item>
            <ThemeProvider theme={theme}>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  lineHeight: "32px",
                }}
              >
                Create Tax
              </Typography>
            </ThemeProvider>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="breadcrumb">
              <Typography className={classes.breadCrumbs}>Home</Typography>

              <Typography className={classes.breadCrumbs}>Master</Typography>

              <Typography className={classes.breadCrumbsActive}>
                Add Tax
              </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Divider className={classes.divider} />
        <Grid container>
          <Grid item xs={4} md={4} sm={4} lg={8} xl={8}>
            <ThemeProvider theme={theme}>
              <Typography variant="h3" className={classes.subtitle}>
                Create Tax
              </Typography>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <p
                style={{
                  marginTop: "5px",
                  color: "#8f8f8f",
                  fontSize: "14px",
                }}
              >
                This feature is to create tax settings for composer/author
              </p>
            </ThemeProvider>

            <Grid container spacing={1}>
              <Grid item xs={6} md={6} sm={6} lg={6} xl={6}>
                <div>
                  <ThemeProvider theme={theme}>
                    <label>Name</label>
                  </ThemeProvider>

                  <TextField
                    variant="outlined"
                    onChange={handleChange}
                    name="name"
                    id="formatted-numberformat-input"
                    margin="dense"
                    fullWidth={true}
                  />
                </div>
              </Grid>
              <Grid item xs={6} md={6} sm={6} lg={6} xl={6}>
                <div>
                  <ThemeProvider theme={theme}>
                    <label>Tax Percentage</label>
                  </ThemeProvider>

                  <TextField
                    value={taxPercentage}
                    variant="outlined"
                    name="taxPercentage"
                    id="formatted-numberformat-input"
                    margin="dense"
                    onChange={handleChange}
                    fullWidth={true}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                      endAdornment: (
                        <InputAdornment position="end">{"%"}</InputAdornment>
                      ),
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
                <div>
                  <ThemeProvider theme={theme}>
                    <label>Description</label>
                  </ThemeProvider>

                  <TextField
                    variant="outlined"
                    onChange={handleChange}
                    name="description"
                    id="formatted-numberformat-input"
                    margin="dense"
                    fullWidth={true}
                    rows={4}
                    multiline
                  />
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{
                  borderRadius: "6px",
                  width: "129px",
                  height: "40px",
                  border: "1px solid #D1D5DC",
                  textTransform: "none",
                }}
                href="/admin/master/tax"
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                style={{
                  textTransform: "none",
                  backgroundColor: "black",
                  color: "white",
                  width: "129px",
                  height: "40px",
                  marginLeft: "10px",
                }}
                onClick={e => saveData(e)}
              >
                <ThemeProvider theme={theme}>
                  <Typography
                    style={{
                      color: "white",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "20px",
                    }}
                  >
                    Save
                  </Typography>
                </ThemeProvider>
              </Button>
            </div>
          </Grid>

          <Grid item xs={4} md={4} sm={4} lg={4} xl={4}></Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default CreateTax;
